import linesConfigurationOptions from "db/line_configuration_options.json";
import { Fragment } from "react";
import { formatLabelSpecs, formatResultsSpecs } from "utils/general";
import Dot from "components/Dot/Dot";
import "./Specs.scss";

const Specs = ({ circles, type }) => (
  <div className="results-view__specs">
    <table className="specs-table">
      <thead className={`${type === "electric" ? "secondary" : ""}`}>
        <tr>
          <th className="value">
            <div className="th-content">
              <Dot color={type === "electric" ? "pink" : "blue"} />
              {type} lines
            </div>
          </th>

          {type !== "electric" &&
            linesConfigurationOptions[type].map((element, i) => (
              <th className="value" key={i}>
                {formatLabelSpecs(element.id)}
              </th>
            ))}
        </tr>
      </thead>
      <tbody>
        {type !== "electric" ? (
          circles
            .filter((value) => value?.type === type)
            .map((element, i) => (
              <Fragment key={i}>
                <tr>
                  <th>Line {element.index}</th>

                  {linesConfigurationOptions[type].map((key, i) => {
                    return (
                      <td className="value" key={i} data-label={formatLabelSpecs(key.id)}>
                        {formatResultsSpecs(element, key, type === "electric")}
                      </td>
                    );
                  })}
                </tr>
              </Fragment>
            ))
        ) : (
          <tr className="secondary">
            <th>{`${
              circles.filter((value) => value?.type === type).length
            } Line${
              circles.filter((value) => value?.type === type).length > 1
                ? "s"
                : ""
            } `}</th>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

export default Specs;
